import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { CHART_BORDER_WIDTH, getSeriesColors, getSeriesFills } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

const shareLabel = (values, index) => {
    const raw = Number(values[index]) || 0;
    const total = values.reduce((sum, item) => sum + (Number(item) || 0), 0);
    const percent = total > 0 ? ((raw / total) * 100).toFixed(1) : '0.0';
    return { raw, percent };
};

function DashboardPieChart({ series = [], showDataLabels = false, tooltipPercent = true }) {
    const labels = series.map((item) => item.label);
    const values = series.map((item) => Number(item.value) || 0);
    const borders = getSeriesColors(series);
    const fills = getSeriesFills(series);

    const options = {
        chart: {
            type: 'pie',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        labels,
        colors: fills,
        fill: { type: 'solid', opacity: 1 },
        dataLabels: {
            enabled: showDataLabels,
            formatter: (val, opts) => {
                const { raw } = shareLabel(values, opts.seriesIndex);
                return `${Math.round(val)}%\n(${raw.toLocaleString()})`;
            },
            style: { fontSize: '11px', fontWeight: 400, colors: ['#181c32'] },
            dropShadow: { enabled: false },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10, radius: 4 },
        },
        stroke: { width: CHART_BORDER_WIDTH, colors: borders },
        states: {
            hover: { filter: { type: 'darken', value: 0.12 } },
        },
        tooltip: {
            enabled: true,
            custom: tooltipPercent
                ? ({ seriesIndex, dataPointIndex }) => {
                      const index = Number.isInteger(seriesIndex) ? seriesIndex : dataPointIndex;
                      const { raw, percent } = shareLabel(values, index);
                      const label = labels[index] || '';
                      return `<div class="dashboard-pie-tooltip">
                            <span class="dashboard-pie-tooltip__swatch" style="background:${borders[index] || '#6366f1'}"></span>
                            <div>
                                <div class="dashboard-pie-tooltip__label">${label}</div>
                                <div class="dashboard-pie-tooltip__value">${raw.toLocaleString()} (${percent}%)</div>
                            </div>
                        </div>`;
                  }
                : undefined,
            y: {
                formatter: (val) => Number(val || 0).toLocaleString(),
            },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={values}
            type="pie"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardPieChart;
